import { useEffect, useState } from "react";
import { getCouponList } from "../../../../apis/pro_forma_invoice.api";
import { getUserCumulativeSum } from "../../../../apis/user.api";
import styles from "./index.module.scss";

export interface PFICouponSectionProps {
  setCouponCodeAfterApply: Function;
  setCouponCodeId: Function;
  setCouponDiscount: Function;
  coupon_discount: any;
  total_md_price_gst: number;
  coupon_code_after_apply: string;
  user_id: string;
  additionalCharges?: any;
  setAdditionalCharges?: (additionalCharges: any) => void;
}

const PFICouponSection = ({
  setCouponCodeAfterApply,
  setCouponCodeId,
  coupon_discount,
  total_md_price_gst,
  setCouponDiscount,
  coupon_code_after_apply,
  user_id,
  additionalCharges,
  setAdditionalCharges,
}: PFICouponSectionProps) => {
  const [coupon_code, setCouponCode] = useState<string>("");
  const [coupon_id, setCouponId] = useState<any>(null);
  const [coupon_list, setCouponList] = useState<Array<any>>([]);
  const [cumulative_sum, setUserCumulativeSum] = useState<number>(0);
  const [discount_error, setDiscountError] = useState<boolean>(false);

  useEffect(() => {
    if (user_id) {
      getCouponList(user_id).then((res) => {
        setCouponList(res);
      });
      getUserCumulativeSum({
        params: {
          user_id: user_id,
        },
      }).then((res) => {
        setUserCumulativeSum(res?.total_estimate_amount_sum);
      });
    }
  }, [user_id]);

  useEffect(() => {}, [total_md_price_gst]);

  const cumulativeCouponAvailable = (total_required: number) => {
    if (total_required - cumulative_sum - total_md_price_gst > 0) {
      return {
        available: false,
        difference: total_required - cumulative_sum - total_md_price_gst,
      };
    } else {
      return {
        available: true,
      };
    }
  };

  const isCouponApplicable = (coupon: any) => {
    if (coupon?.is_product_in_cart === false) return false;
    if (!cumulativeCouponAvailable(coupon?.cumulative_sum_above)?.available)
      return false;
    if (coupon?.min_cart_value && total_md_price_gst < coupon?.min_cart_value)
      return false;
    if (coupon?.max_cart_value && total_md_price_gst > coupon?.max_cart_value)
      return false;
    return true;
  };

  const getRemainingAmountNeededTOApplyOffer = (coupon: any) => {
    const cumulativeGap =
      (coupon?.cumulative_sum_above || 0) - cumulative_sum - total_md_price_gst;
    const minCartGap = (coupon?.min_cart_value || 0) - total_md_price_gst;
    return parseInt(Math.max(cumulativeGap, minCartGap, 0)?.toString());
  };

  return (
    <div className={"mt-3  p-4 rounded-3 " + styles.card_shadow}>
      <div className="th-fontSize-20 th-fontWeight-500">
        Apply Coupon {total_md_price_gst}
      </div>
      {coupon_code_after_apply?.length > 0 ? (
        <div className="mt-3 border rounded-1 p-2 px-3 medium-green-color-bg green-color-border">
          <div className="row">
            <div className="col">
              <div className="th-fontWeight-600 whatsapp-green-color-text ">
                You Save : Rs.{coupon_discount}
              </div>
              <div className="bright-yellow-brown-color-text">
                Coupon Applied :{" "}
                <span className="th-fontWeight-600">{coupon_code}</span>
              </div>
            </div>
            <div className="col-2 align-items-center justify-content-end d-flex">
              {" "}
              <div
                onClick={() => {
                  setCouponCode("");
                  setCouponId(null);
                  setCouponCodeAfterApply("");
                  setCouponCodeId(null);
                  setCouponDiscount(0);

                  if (
                    additionalCharges &&
                    Array.isArray(additionalCharges) &&
                    setAdditionalCharges
                  ) {
                    setAdditionalCharges(
                      additionalCharges.filter(
                        (charge) =>
                          charge?.charge_type !==
                          "Coupon Discount - Free Delivery"
                      )
                    );
                  }
                }}
                className="btn"
              >
                Remove
              </div>
            </div>
          </div>
        </div>
      ) : (
        <>
          {" "}
          <div className="d-flex mt-2 row gap-0">
            <div className="col">
              <input
                className="p-2 border border-secondary rounded w-100 "
                placeholder="Enter coupon code"
                value={coupon_code}
                onChange={(e) => {
                  setCouponCode(e.target.value?.toUpperCase());
                  setCouponId(coupon_id);
                }}
              />
            </div>
            <div
              className={
                "col-3 btn " +
                (coupon_code_after_apply?.length > 0
                  ? "primary-color-background white-color-text"
                  : " border border-dark")
              }
              onClick={() => {
                if (coupon_code?.length > 0) {
                  setCouponCodeAfterApply(coupon_code);
                  // A clicked coupon has its id here; a typed one (incl. a hidden
                  // coupon, which is never in coupon_list) gets it from the pricing
                  // call in the parent, which also adds the free-delivery offset.
                  const listed = coupon_list.find(
                    (coupon) => coupon?.coupon_code === coupon_code
                  );
                  setCouponCodeId(listed?.id ?? coupon_id);
                }
              }}
            >
              Apply
            </div>
          </div>
          {discount_error && (
            <div className="brick-red-color-text mt-2">Invalid Coupon</div>
          )}
        </>
      )}
      <div className="mt-2 green-color-text">
        User current cumulative amount :{" "}
        <span className="th-fontWeight-600">₹{cumulative_sum}</span>
      </div>

      <div
        className={
          (coupon_code_after_apply?.length > 0 && " opacity-50 pe-none ") +
          " py-3"
        }
      >
        {coupon_list.filter((coupon) => isCouponApplicable(coupon))?.length >
          0 && (
          <>
            {" "}
            <div className="th-fontSize-18 mb-2 th-fontWeight-500">
              Applicable Coupons
            </div>
            {coupon_list
              .filter((coupon) => isCouponApplicable(coupon))
              .map((coupon, index) => {
                return (
                  <div
                    onClick={() => {
                      setCouponCode(coupon?.coupon_code?.toUpperCase());
                      setCouponId(coupon?.id);
                    }}
                    className="cursor-pointer d-flex"
                  >
                    <div className="form-check">
                      <input
                        className="form-check-input cursor-pointer"
                        type="radio"
                        name="coupon"
                        id={"coupon" + index}
                        checked={coupon_code == coupon?.coupon_code}
                        onChange={(e) => {}}
                      />
                      <label
                        className="form-check-label w-100 cursor-pointer"
                        htmlFor={"coupon" + index}
                      >
                        <div className="th-fontSize-16 th-fontWeight-500">
                          {coupon?.coupon_code}{" "}
                        </div>

                        <div className="th-fontSize-14 th-fontWeight-400">
                          Get{" "}
                          <span
                            className={
                              "th-fontSize-16 th-fontWeight-600 " +
                              styles?.gradient_text
                            }
                          >
                            {coupon?.coupon_value}
                            {coupon?.type == "percentage" && "%"} OFF{" "}
                          </span>
                          on Total Cumulative order value of Rs.{" "}
                          {coupon?.cumulative_sum_above} and above
                        </div>
                        <div
                          className={
                            "th-fontSize-12 th-fontWeight-400 blue-color-text "
                          }
                        >
                          View T & C
                        </div>
                      </label>
                    </div>
                    <div></div>
                  </div>
                );
              })}
          </>
        )}
        <br />
        {coupon_list.filter((coupon) => !isCouponApplicable(coupon))?.length >
          0 && (
          <>
            {" "}
            <div className="th-fontSize-18 mb-2 th-fontWeight-500">
              Non Applicable Coupons
            </div>
            {coupon_list
              .filter((coupon) => !isCouponApplicable(coupon))
              .map((coupon, index) => {
                return (
                  <div
                    onClick={() => {
                      // setCouponCode(coupon?.coupon_code?.toUpperCase());
                      // window.scrollTo({ top: 250, behavior: "smooth" });
                    }}
                    className="cursor-pointer my-2"
                  >
                    <div className="form-check">
                      <input
                        className="form-check-input cursor-pointer"
                        type="radio"
                        name="coupon"
                        id={"coupon" + index}
                        disabled={true}
                        checked={coupon_code == coupon?.coupon_code}
                        onChange={(e) => {}}
                      />
                      <label
                        className="form-check-label w-100 cursor-pointer"
                        htmlFor={"coupon" + index}
                      >
                        <div className="th-fontSize-16 th-fontWeight-500">
                          {coupon?.coupon_code}{" "}
                        </div>

                        <div className="th-fontSize-14 th-fontWeight-400">
                          Get{" "}
                          <span
                            className={
                              "th-fontSize-16 th-fontWeight-600 " +
                              styles?.gradient_text
                            }
                          >
                            {coupon?.coupon_value}
                            {coupon?.type == "percentage" && "%"} OFF{" "}
                          </span>
                          on Total Cumulative order value of Rs.{" "}
                          {coupon?.cumulative_sum_above} and above
                        </div>
                        <div
                          className={
                            "th-fontSize-12 th-fontWeight-400 blue-color-text "
                          }
                        >
                          View T & C
                        </div>
                      </label>
                    </div>

                    <div className="px-4 th-fontSize-14 bright-yellow-brown-color-text">
                      {coupon?.is_product_in_cart === false ? (
                        "Add eligible products to cart to apply this offer"
                      ) : (
                        <>
                          Shop for ₹
                          {getRemainingAmountNeededTOApplyOffer(coupon)}{" "}
                          more to apply offer
                        </>
                      )}
                    </div>
                  </div>
                );
              })}
          </>
        )}
      </div>
    </div>
  );
};

export default PFICouponSection;
